export function useAuth() {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("userToken");
    return {
      role: user?.role || 'guest',
      currentUserId: user?._id,
      user,
      token
    }
}
  